import axios from 'axios';
import {
  APP_SETTING_LOAD_PAGE_SNAPSHOTS_BEGIN,
  APP_SETTING_LOAD_PAGE_SNAPSHOTS_SUCCESS,
  APP_SETTING_LOAD_PAGE_SNAPSHOTS_FAILURE,
  APP_SETTING_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPageSnapshots(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PAGE_SNAPSHOTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/page-snapshots/${projectId}/project`,
        header,
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_PAGE_SNAPSHOTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PAGE_SNAPSHOTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPageSnapshotsError() {
  return {
    type: APP_SETTING_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PAGE_SNAPSHOTS_BEGIN:
      return {
        ...state,
        loadPageSnapshotsPending: true,
        loadPageSnapshotsError: null,
      };

    case APP_SETTING_LOAD_PAGE_SNAPSHOTS_SUCCESS:
      return {
        ...state,
        loadPageSnapshotsPending: false,
        loadPageSnapshotsError: null,
        showPageSnapshotName: false,
        pageSnapshots: action.data,
      };

    case APP_SETTING_LOAD_PAGE_SNAPSHOTS_FAILURE:
      return {
        ...state,
        loadPageSnapshotsPending: false,
        loadPageSnapshotsError: action.data.error,
      };

    case APP_SETTING_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR:
      return {
        ...state,
        loadPageSnapshotsError: null,
      };

    default:
      return state;
  }
}
